
import Vue, { PropType } from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { SearchUserObject } from "@/interfaces/shared/auto_complete_user_search";
import { TranslateResult } from "vue-i18n";
import {
  USER_WITH_EID_AND_NAME,
  SELECTED_USER_BY_EID_NAME,
  RESER_USER_EID_NAME,
  USER_INFO_BY_EID_NAME
} from "@/store/modules/common/constants";
import { VIEW_CANDIDATE_FILTER } from "@/store/modules/recruiter_admin/constants";
import { ViewCandidatesOptions } from "@/interfaces/recruiter/admin/all_candidates";
export default Vue.extend({
  name: "AutoCompleteUserSearch",
  data() {
    return {
      selected_searched_user: [] as SearchUserObject[],
      searched_users: [] as SearchUserObject[],
      search_input: null,
      debounceTimer: null as ReturnType<typeof setTimeout> | null,
      abortController: null as AbortController | null,
      dropdown_icon: require("@/assets/icons/linear/direction-down.svg")
    };
  },
  computed: {
    ...mapGetters("common", {
      get_user: USER_INFO_BY_EID_NAME,
      fetch_users: SELECTED_USER_BY_EID_NAME
    }),
    ...mapGetters("recruiter_admin", {
      get_candidate_filter: VIEW_CANDIDATE_FILTER
    })
  },
  props: {
    hide_details: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String as PropType<TranslateResult>,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.get_user?.length) {
      this.searched_users = this.get_user.map((user: SearchUserObject) => ({
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        text: `${user.first_name} ${user.last_name ? user.last_name : ""}`,
        avatar_uri: user.avatar_uri,
        email: user.email
      }));
    }
    if (this.fetch_users?.length) {
      this.selected_searched_user = this.fetch_users;
    }
  },
  watch: {
    /**
     * Function to Fetch Users on the base of input
     */
    async search_input(value) {
      if (value !== null) {
        let payload = "search=" + value;
        // if (this.placeholder === this.$t("auth.name")) {
        //   payload = "input=" + value;
        // } else if (this.placeholder === this.$t("auth.eid-number")) {
        //   payload = "eid=" + value;
        // } else {
        //   payload = "email=" + value;
        // }

        if (this.get_candidate_filter === ViewCandidatesOptions.DECLINED)
          payload += `&removed=true`;
        this.queueSearch(payload);
        return;
      }
    },
    placeholder() {
      if (this.selected_searched_user.length > 0) {
        this.reset_state();
        this.$emit("searched_user", []);
      }
    }
  },
  methods: {
    queueSearch(query: string) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      this.debounceTimer = setTimeout(async () => {
        const result = await this.autocomplete_user_search({
          query,
          signal: this.abortController ? this.abortController.signal : undefined
        });
        if (result?.length > 0) {
          const filteredResult = result.filter(
            (item: SearchUserObject) =>
              !this.selected_searched_user?.some(
                (selectedItem: SearchUserObject) => selectedItem?.id === item.id
              )
          );
          this.searched_users = [
            ...this.selected_searched_user,
            ...filteredResult
          ].map((user: SearchUserObject) => ({
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            text: `${user.first_name} ${user.last_name ? user.last_name : ""}`,
            avatar_uri: user.avatar_uri,
            email: user.email
          }));
        }
      }, 300);
    },
    on_change(value: SearchUserObject[]) {
      this.set_selected_users(value);
      this.$emit("searched_user", value);
    },
    ...mapActions("common", {
      autocomplete_user_search: USER_WITH_EID_AND_NAME
    }),
    ...mapMutations("common", {
      set_selected_users: SELECTED_USER_BY_EID_NAME,
      reset_users: RESER_USER_EID_NAME
    }),
    on_clear_selected_users() {
      this.reset_state();
      this.$emit("searched_user", []);
    },
    on_input() {
      this.search_input = null;
    },
    remove_selected_item(id: number) {
      this.selected_searched_user = this.selected_searched_user.filter(
        (item: SearchUserObject) => item.id !== id
      );
      this.$emit("searched_user", this.selected_searched_user);
    },
    reset_state() {
      this.selected_searched_user = [];
      this.searched_users = [];
      this.search_input = null;
      this.reset_users();
    },
    display_name(item: SearchUserObject) {
      return `${item.first_name} ${item.last_name ? item.last_name : ""}`;
    }
  }
});
